import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import FilterChip from 'LuxKit/Chips/FilterChip'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import ListingDrawerTitleGroup from '../ListingDrawerTitleGroup'
import type { HotelListingDrawerHeaderProps } from './types'

function HotelListingDrawerHeader({
  placeName,
  placeCountry,
  onExploreMap,
}: HotelListingDrawerHeaderProps) {
  const intl = useIntl()

  return (
    <Group
      direction="horizontal"
      gap={16}
      horizontalAlign="space-between"
      verticalAlign="start"
    >
      <ListingDrawerTitleGroup direction="vertical" gap={4}>
        <Heading variant="heading2">
          {intl.formatMessage(
            {
              id: 'G-nNmBr53dHAL8cBtSNe',
              defaultMessage: 'Hotels in {placeName}',
              description: 'Heading for hotel listing drawer showing hotels in a specific place',
            },
            { placeName },
          )}
        </Heading>
        <BodyText variant="medium" colour="neutral-two">
          {intl.formatMessage(
            {
              id: '1AhR5yM5BWuUDRQPUrWC',
              defaultMessage: '{placeName}, {placeCountry}',
              description: 'Hotel listing drawer header place name and country separated by comma',
            },
            { placeName, placeCountry },
          )}
        </BodyText>
      </ListingDrawerTitleGroup>

      {onExploreMap && (
        <FilterChip
          size="medium"
          startIcon={<LineMapIcon />}
          onClick={onExploreMap}
        >
          {intl.formatMessage({
            id: 'jcH-AcKGdZjLXZnnZGK9',
            defaultMessage: 'Explore more',
            description:
              'Chip label on the trip planner hotel listing drawer header that opens map explore for hotels at the current itinerary stop.',
          })}
        </FilterChip>
      )}
    </Group>
  )
}

export default HotelListingDrawerHeader
